import { usePartnerAccountsState } from './usePartnerAccountsState';

export function useAdvisoryPartnerAccountsState({ adminFetch }) {
  return usePartnerAccountsState({
    adminFetch,
    endpoint: '/admin/advisory/partners',
    role: 'advisory_partner',
    roleLabel: 'Advisory Partner',
  });
}
